// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"c06c405c8f7568466c4f","351":"753ce211e988efa48a1a","532":"14ed125bf4dc29603124","691":"93336af7f6d3875d4cd7"}[chunkId] + ".js";
};